export default function StepperTabs({ step }) {
  const tabs = ["Getting Started", "Basic Details", "Application Details"];

  return (
    <div className="relative flex items-center justify-between mb-12 px-4">
      {/* Connector Line Behind Circles */}
      <div className="absolute top-[26px] left-0 right-0 z-0 flex items-center">
        {tabs.slice(0, -1).map((_, i) => (
          <div key={i} className="flex-1 flex">
            <div
              className={`h-1 w-full ${
                step > i + 1 ? "bg-green-400" : "bg-gray-300"
              }`}
            ></div>
          </div>
        ))}
      </div>

      {/* Steps */}
      {tabs.map((label, i) => {
        const isActive = step === i + 1;
        const isCompleted = step > i + 1;

        return (
          <div
            key={i}
            className="relative z-10 flex flex-col items-center w-1/3"
          >
            {/* Circle */}
            <div
              className={`w-10 h-10 rounded-full border-2 flex items-center justify-center font-medium transition-all duration-300
                ${
                  isCompleted
                    ? "bg-green-100 border-green-500 text-green-600"
                    : isActive
                    ? "bg-blue-100 border-blue-500 text-blue-600 shadow"
                    : "bg-white border-gray-300 text-gray-400"
                }`}
            >
              {isCompleted ? (
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              ) : (
                i + 1
              )}
            </div>

            {/* Label */}
            <div
              className={`mt-2 text-lg text-center ${
                isActive
                  ? "text-blue-600"
                  : isCompleted
                  ? "text-green-600"
                  : "text-gray-400"
              }`}
            >
              {label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
